<template>
	<div class="fixed z-[1070] h-screen w-screen bg-black/70 text-white backdrop-blur dark:bg-[#21262d]/40">
		<div class="mx-auto flex h-full w-full max-w-[600px] flex-col items-center justify-center gap-4 px-5">
			<h1 class="text-center text-2xl font-bold">Welcome to TeleFlow</h1>
			<h2 class="text-center text-lg">
				Thank you for creating an account, we have received your request to join TeleFlow and will likely be in
				touch soon regarding the creation of your account.
			</h2>
			<h3 class="text-center">
				Once we set you up, you will not see this page again and will be entered in to the TeleFlow web
				application.
			</h3>
			<h4 class="text-center">
				If you have any questions, please email us at:
				<a href="mailto:support@teleflow.co.uk">support@teleflow.co.uk</a> and please feel free to browse our
				documentation whilst you wait.
			</h4>
			<div class="row flex-nowrap items-center gap-4">
				<a
					class="jmiBtn blue rounded-sm px-6 py-2 text-center text-white shadow-lg hover:text-light"
					target="_blank"
					href="https://docs.teleflow.app"
					>View Documentation</a
				>
				<button
					class="jmiBtn red rounded-sm px-6 py-2 text-center text-white shadow-lg hover:text-light"
					@click="logout"
				>
					Switch User
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {}
	},
	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		logout() {
			this.$auth0.logout({ logoutParams: { returnTo: window.location.origin } })
		}
	}
}
</script>
